import { useMemo } from 'react';
import classNames from './DeleteStudentsPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import {
  BulkOperationResponseData,
  MoveStudentsBulkOperationItem,
  BulkOperationState,
} from '@/school-management/types/services/bulk';
import Button from '@/components/school-management/Button/Button';
import StudentsTable, {
  convertStudentReportItemToStudentsTableData,
} from './StudentsTablePartialSuccesses';
import Download from './Download';

interface PartialSuccessesProps {
  students: StudentReportItem[];
  bulkOperation?: BulkOperationResponseData;
  onClose: () => void;
}

const PartialSuccesses = ({ students, bulkOperation, onClose }: PartialSuccessesProps) => {
  const { t } = useAdminTranslation();

  const studentsTableData = useMemo(() => {
    const studentsToProcess = students || [];

    const bulkStudentsMapper = (
      (bulkOperation?.results || []) as MoveStudentsBulkOperationItem[]
    ).reduce(
      (acc, s) => {
        if (s.studentId) {
          acc[s.studentId] = s;
        }

        return acc;
      },
      {} as {
        [studentId: string]: MoveStudentsBulkOperationItem;
      }
    );

    return studentsToProcess.map(s => {
      const isSuccess =
        s.userId in bulkStudentsMapper ? bulkStudentsMapper[s.userId].success : true;
      return convertStudentReportItemToStudentsTableData(s, isSuccess, t);
    });
  }, [students, bulkOperation, t]);

  return (
    <>
      <div>
        <div className={classNames.title} style={{ fontSize: '26px' }}>
          {t('bulkActions.common.partialSuccessTitle')}
        </div>
        <div className={classNames.description}>
          {t('bulkActions.deleteStudents.partialSuccesses.description')}
        </div>
      </div>
      <StudentsTable students={studentsTableData} />
      <Download
        students={students}
        bulkOperation={bulkOperation}
        bulkOperationState={BulkOperationState.PartialSuccess}
      />
      <div className={classNames.footer}>
        <Button className={classNames.button} onClick={onClose}>
          {t('ok')}
        </Button>
      </div>
    </>
  );
};

export default PartialSuccesses;
